export default function AboutTeam() {
  return (
    <section className="bg-zinc-950 py-24 border-t border-zinc-800/50">
      <div className="max-w-7xl mx-auto px-6">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <p className="text-orange-400 text-xs uppercase tracking-widest font-semibold mb-3">Za Boostio</p>
            <h2 className="text-4xl md:text-5xl font-black text-white leading-tight">
              Jeden zodpovedný.<br />Overená sieť.
            </h2>
          </div>
          <p className="text-zinc-500 text-base max-w-sm leading-relaxed">
            Žiadni account manažéri medzi tebou a výsledkom. Komunikuješ priamo so mnou - a za každým projektom stojím osobne.
          </p>
        </div>

        {/* Founder card */}
        <div className="bg-zinc-900/50 border border-zinc-800/60 rounded-2xl overflow-hidden mb-6">
          <div className="flex flex-col md:flex-row">
            {/* Photo */}
            <div className="md:w-72 lg:w-80 flex-shrink-0">
              <div className="w-full h-72 md:h-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20young%20Slovak%20man%20confident%20smile%20business%20casual%20dark%20hair%20modern%20clean%20studio%20background%20neutral%20tones%20digital%20entrepreneur%20developer%20portrait%20professional%20headshot%20photography&width=480&height=560&seq=kamil-frajtko-ceo&orientation=portrait"
                  alt="Bc. Kamil Frajtko - CEO Boostio"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 p-8 md:p-10 flex flex-col justify-center">
              <div className="flex flex-wrap items-center gap-2.5 mb-4">
                <span className="bg-orange-500/10 border border-orange-500/20 text-orange-400 text-xs font-bold px-3 py-1 rounded-full">
                  Zakladateľ & CEO
                </span>
                <span className="text-zinc-600 text-xs">kamilfrajtko.sk</span>
              </div>

              <h3 className="text-white font-black text-2xl md:text-3xl mb-2">Bc. Kamil Frajtko</h3>
              <p className="text-zinc-400 text-sm mb-5 leading-relaxed max-w-xl">
                Spájam technickú exekúciu, funkčný dizajn a biznis pohľad - výsledok musí nielen dobre vyzerať,
                ale aj fungovať v praxi. Na projektoch mi nezáleží len na tom, čo odovzdám, ale aj na tom,
                či to skutočne pomáha biznisu rásť.
              </p>

              {/* Skills */}
              <div className="flex flex-wrap gap-2 mb-7">
                {['Webové projekty', 'E-shopy', 'Automatizácie', 'Redesign & UX', 'Interné systémy', 'Dlhodobá podpora'].map((skill) => (
                  <span
                    key={skill}
                    className="text-zinc-400 text-xs bg-zinc-800/70 border border-zinc-700/50 px-2.5 py-1 rounded-full whitespace-nowrap"
                  >
                    {skill}
                  </span>
                ))}
              </div>

              {/* Quote */}
              <blockquote className="border-l-2 border-orange-500/50 pl-4 mb-7">
                <p className="text-zinc-500 text-sm italic leading-relaxed">
                  „Partner, nie len dodávateľ. Záleží mi na tom, aby projekt mal zmysel v každodennej prevádzke - nielen pri odovzdaní."
                </p>
              </blockquote>

              {/* Links */}
              <div className="flex items-center gap-3">
                <a
                  href="https://kamilfrajtko.sk/o-mne/"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700/60 text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-user-line" />
                  Viac o mne
                </a>
                <a
                  href="https://www.linkedin.com/in/kamilfrajtko"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="w-10 h-10 flex items-center justify-center border border-zinc-700/60 hover:border-orange-500/40 hover:bg-orange-500/10 rounded-lg transition-all duration-200 text-zinc-500 hover:text-orange-400 cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-sm" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Honest note */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-20">
          {[
            {
              icon: 'ri-focus-3-line',
              title: 'Priamy kontakt',
              desc: 'Komunikuješ priamo so mnou - žiadny account manažér, žiadny telefónny zoznam.',
            },
            {
              icon: 'ri-group-line',
              title: 'Overení špecialisti',
              desc: 'Na väčšie projekty sú zapojení preverení freelanceri - vždy tá správna odbornosť.',
            },
            {
              icon: 'ri-shield-check-line',
              title: 'Osobná zodpovednosť',
              desc: 'Za výsledok ručím ja. Nie anonymný tím - ale konkrétny človek s menom a reputáciou.',
            },
          ].map((item) => (
            <div
              key={item.title}
              className="bg-zinc-900/40 border border-zinc-800/50 rounded-xl p-5 flex gap-4"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-orange-500/10 border border-orange-500/20 rounded-lg flex-shrink-0 mt-0.5">
                <i className={`${item.icon} text-orange-400 text-base`} />
              </div>
              <div>
                <h4 className="text-white font-semibold text-sm mb-1">{item.title}</h4>
                <p className="text-zinc-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Partners - CreateUp */}
        <div>
          <div className="flex items-center gap-4 mb-8">
            <div className="h-px flex-1 bg-zinc-800/60" />
            <p className="text-zinc-600 text-xs uppercase tracking-widest font-semibold whitespace-nowrap">
              Spolupracujem s
            </p>
            <div className="h-px flex-1 bg-zinc-800/60" />
          </div>

          <div className="bg-zinc-900/40 border border-zinc-800/60 hover:border-zinc-700/80 rounded-2xl overflow-hidden transition-all duration-300">
            <div className="flex flex-col lg:flex-row">
              {/* Studio image */}
              <div className="lg:w-96 flex-shrink-0">
                <div className="w-full h-56 lg:h-full overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20professional%20podcast%20recording%20studio%20interior%20with%20microphones%20ring%20lights%20dark%20moody%20atmosphere%20red%20accent%20lighting%20professional%20equipment%20clean%20minimal%20setup%20photography%20studio&width=600&height=420&seq=createup-studio&orientation=landscape"
                    alt="CreateUp štúdio v Prešove"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 p-8 md:p-10">
                <div className="flex flex-wrap items-center gap-2.5 mb-4">
                  <span className="bg-red-500/10 border border-red-500/20 text-red-400 text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-red-400" />
                    Overený partner
                  </span>
                  <span className="text-zinc-600 text-xs">Prešov, Slovensko</span>
                </div>

                <h3 className="text-white font-black text-2xl mb-1">CREATE UP</h3>
                <p className="text-zinc-500 text-sm mb-5">createup.sk</p>

                <p className="text-zinc-400 text-sm leading-relaxed mb-6 max-w-xl">
                  Foto a podcastové štúdio v Prešove. Keď klienti Boostio potrebujú profesionálny vizuálny obsah,
                  vedia kde ísť - portrétna a produktová fotografia, videopodcasty, live streamy a eventový priestor
                  pre workshopy a biznis stretnutia.
                </p>

                {/* Services */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-7">
                  {[
                    { icon: 'ri-camera-lens-line', label: 'Foto štúdio' },
                    { icon: 'ri-mic-2-line', label: 'Podcast štúdio' },
                    { icon: 'ri-live-line', label: 'Live streamy' },
                    { icon: 'ri-calendar-event-line', label: 'Workshopy & Eventy' },
                  ].map((s) => (
                    <div
                      key={s.label}
                      className="bg-zinc-800/50 border border-zinc-700/40 rounded-xl p-3 text-center"
                    >
                      <div className="w-8 h-8 flex items-center justify-center mx-auto mb-1.5">
                        <i className={`${s.icon} text-orange-400 text-lg`} />
                      </div>
                      <p className="text-zinc-300 text-xs font-medium leading-tight">{s.label}</p>
                    </div>
                  ))}
                </div>

                <a
                  href="https://createup.sk"
                  target="_blank"
                  rel="nofollow noreferrer"
                  className="inline-flex items-center gap-2 bg-zinc-800 hover:bg-zinc-700 border border-zinc-700/60 text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-external-link-line" />
                  Navštíviť createup.sk
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
